(() => {
  if (customElements.get('detropolis-street-map')) return;
  let scrollLocks = 0;
  let previousOverflow = '';
  const lockScroll = () => {
    if (!scrollLocks++) {
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
    }
    let released = false;
    return () => {
      if (released) return;
      released = true;
      if (!--scrollLocks) document.documentElement.style.overflow = previousOverflow;
    };
  };
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  function renderPackHighlights(root) {
    root.querySelectorAll('[data-pack-highlight]').forEach(node => {
      const source = node.textContent;
      const fragment = document.createDocumentFragment();
      const pattern = /\[\[([^\[\]]+)\]\]/g;
      let cursor = 0;
      let match;
      while ((match = pattern.exec(source))) {
        fragment.append(document.createTextNode(source.slice(cursor, match.index)));
        const highlight = document.createElement('span');
        highlight.className = 'dt-street-map__highlight';
        highlight.textContent = match[1];
        fragment.append(highlight);
        cursor = pattern.lastIndex;
      }
      if (cursor) {
        fragment.append(document.createTextNode(source.slice(cursor)));
        node.replaceChildren(fragment);
      }
      const player = node.parentElement.classList.contains('dt-street-map__sample-row')
        ? node.parentElement.querySelector('[data-street-player]') : null;
      if (player) player.dataset.title = node.textContent;
    });
  }

  function seededHeight(seed, index) {
    var value = Math.sin(seed * 999 + index * 12.9898) * 43758.5453;
    var normalized = value - Math.floor(value);
    var shape = Math.sin(index * 0.31 + seed) * 0.5 + 0.5;
    return Math.round(12 + normalized * 46 + shape * 34);
  }

  function parsePeaks(peaksString) {
  if (!peaksString || typeof peaksString !== 'string') return null;

  var cleaned = peaksString
    .replace(/\[/g, '')
    .replace(/\]/g, '')
    .replace(/\n/g, ',')
    .replace(/\s+/g, ',');

  var values = cleaned
    .split(',')
    .map(function (value) {
      return Number(value.trim());
    })
    .filter(function (value) {
      return !isNaN(value) && isFinite(value);
    });

  if (!values.length) return null;

  return values;
}

function normalizePeaks(values) {
  var max = Math.max.apply(null, values);
  var min = Math.min.apply(null, values);

  if (max <= 0) return values.map(function () { return 12; });

  return values.map(function (value) {
    var normalized;

    if (max <= 1) {
      normalized = value * 100;
    } else if (max <= 100) {
      normalized = value;
    } else {
      normalized = (value / max) * 100;
    }

    return Math.max(8, Math.min(100, Math.round(normalized)));
  });
}

function resamplePeaks(values, total) {
  if (!values || !values.length) return null;
  if (values.length === total) return values;

  var result = [];

  for (var i = 0; i < total; i += 1) {
    var start = Math.floor((i / total) * values.length);
    var end = Math.floor(((i + 1) / total) * values.length);

    if (end <= start) end = start + 1;

    var sum = 0;
    var count = 0;

    for (var j = start; j < end && j < values.length; j += 1) {
      sum += values[j];
      count += 1;
    }

    result.push(count ? Math.round(sum / count) : values[start] || 10);
  }

  return result;
}

function getPlayerStyles(playerOrElement) {
  var el = playerOrElement.el || playerOrElement;
  var styles = window.getComputedStyle(el);

  return {
    inactiveColor: styles.getPropertyValue('--wave-color').trim() || '#6f6a78',
    activeColor: styles.getPropertyValue('--wave-progress-color').trim() || '#ff174f',
    buttonColor: styles.getPropertyValue('--audio-button-color').trim() || '#ffffff',
    gap: parseFloat(styles.getPropertyValue('--wave-gap')) || 3
  };
}

function drawWaveCanvas(player, ratio) {
  if (!player || !player.canvas || !player.peaks) return;

  ratio = Math.max(0, Math.min(1, ratio || 0));

  var canvas = player.canvas;
  var ctx = canvas.getContext('2d');
  if (!ctx) return;
  var wrap = player.waveWrap || player.wave;
  var rect = wrap.getBoundingClientRect();

  if (!rect.width || !rect.height) return;

  var dpr = window.devicePixelRatio || 1;
  var width = Math.round(rect.width * dpr);
  var height = Math.round(rect.height * dpr);

  if (canvas.width !== width || canvas.height !== height) {
    canvas.width = width;
    canvas.height = height;
  }

  canvas.style.width = rect.width + 'px';
  canvas.style.height = rect.height + 'px';

  ctx.clearRect(0, 0, width, height);

  var styles = getPlayerStyles(player);
  var total = player.peaks.length;
  var gap = Math.max(.5, Math.min(styles.gap * dpr, width / total * .4));
  var availableWidth = width - gap * (total - 1);
  var barWidth = Math.max(1, availableWidth / total);
  var radius = Math.min(barWidth / 2, 999);
  var activeCount = Math.round(ratio * total);

  for (var i = 0; i < total; i += 1) {
    var peak = player.peaks[i] || 8;
    var barHeight = Math.max(3 * dpr, (peak / 100) * height);
    var x = i * (barWidth + gap);
    var y = (height - barHeight) / 2;

    ctx.fillStyle = i < activeCount ? styles.activeColor : styles.inactiveColor;

    if (ctx.roundRect) {
      ctx.beginPath();
      ctx.roundRect(x, y, barWidth, barHeight, radius);
      ctx.fill();
    } else {
      ctx.fillRect(x, y, barWidth, barHeight);
    }
  }

  if (player.button) {
    player.button.style.color = styles.buttonColor;
  }
}


  const audioManager = window.SOUNPLACE_AUDIO_MANAGER ||= { current: null, players: [] };
  function streetPlayer(el, owner) {
    const events = new AbortController();
    const audio = new Audio();
    audio.preload = 'none';
    audio.playsInline = true;
    const button = el.querySelector('[data-street-play]');
    const wave = el.querySelector('[data-street-wave]');
    const canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    wave.append(canvas);
    const player = { el, audio, button, wave, waveWrap: wave, canvas, peaks: [], raf: 0, pendingSeekRatio: null };
    const listen = (node, type, fn) => node.addEventListener(type, fn, { signal: events.signal });
    const time = seconds => `${Math.floor((seconds || 0) / 60)}:${String(Math.floor((seconds || 0) % 60)).padStart(2, '0')}`;
    const clock = el.querySelector('[data-street-time]');
    const message = el.querySelector('[data-audio-message]');
    let source = '', attempt = 0, seek = null;
    const paint = () => {
      const duration = Number.isFinite(audio.duration) ? audio.duration : 0;
      const ratio = typeof player.pendingSeekRatio === 'number' ? player.pendingSeekRatio : duration ? audio.currentTime / duration : 0;
      drawWaveCanvas(player, ratio);
      if (clock) clock.textContent = `${time(audio.currentTime)} / ${time(duration)}`;
      wave.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
      wave.setAttribute('aria-valuetext', `${time(audio.currentTime)} de ${time(duration)}`);
    };
    const update = () => {
      button.textContent = audio.paused ? '▶' : '❚❚';
      button.setAttribute('aria-label', `${audio.paused ? 'Reproducir' : 'Pausar'} ${el.dataset.title || 'muestra'}`);
      el.classList.toggle('is-playing', !audio.paused);
      paint();
    };
    player.paint = paint;
    player.setSource = (url, peaks = '', title = '') => {
      if (title) el.dataset.title = title;
      const candidate = String(url || '').trim();
      const clean = /^(https?:|blob:|data:audio\/)/i.test(candidate) ? candidate : '';
      if (clean !== source) {
        ++attempt;
        audio.pause();
        player.pendingSeekRatio = null;
        source = clean;
        if (clean) audio.src = clean;
        else { audio.removeAttribute('src'); audio.load(); }
      }
      const values = parsePeaks(peaks);
      player.peaks = values?.length ? resamplePeaks(normalizePeaks(values), 80) : Array.from({ length: 80 }, (_, i) => seededHeight(clamp(Number(el.dataset.seed) || 12, 1, 1000), i));
      button.disabled = !source;
      wave.tabIndex = source ? 0 : -1;
      wave.setAttribute('aria-disabled', String(!source));
      message.textContent = source ? '' : 'Audio no disponible';
      update();
    };
    player.pause = () => { ++attempt; audio.pause(); update(); };
    player.play = async () => {
      if (!source) return;
      owner.stopBonusVideo?.({ keepPreview:true });
      audioManager.players.forEach(other => {
        if (other === player) return;
        if (typeof other.pause === 'function') other.pause();
        else {
          other.audio?.pause(); cancelAnimationFrame(other.raf);
          if (other.button) { other.button.textContent = '▶'; other.button.setAttribute('aria-label', 'Reproducir audio'); }
        }
      });
      audioManager.current = player;
      if (Number.isFinite(audio.duration) && player.pendingSeekRatio !== null) {
        audio.currentTime = player.pendingSeekRatio * audio.duration;
        player.pendingSeekRatio = null;
      }
      const token = ++attempt;
      message.textContent = '';
      try { if (audio.error) audio.load(); await audio.play(); }
      catch (error) {
        if (token !== attempt || error.name === 'AbortError') return;
        message.textContent = error.name === 'NotAllowedError' ? 'Pulsa reproducir para escuchar.' : 'No se pudo cargar el audio. Pulsa reproducir para reintentar.';
        if (audioManager.current === player) audioManager.current = null;
      }
      update();
    };
    const commit = ratio => {
      player.pendingSeekRatio = clamp(ratio, 0, 1);
      if (Number.isFinite(audio.duration)) {
        audio.currentTime = player.pendingSeekRatio * audio.duration;
        player.pendingSeekRatio = null;
      }
      paint();
    };
    const ratioAt = event => {
      const box = wave.getBoundingClientRect();
      return clamp((event.clientX - box.left) / Math.max(1, box.width), 0, 1);
    };
    listen(button, 'click', () => audio.paused ? player.play() : player.pause());
    listen(wave, 'pointerdown', event => { if (source) seek = { id: event.pointerId, x: event.clientX, y: event.clientY, active: false }; });
    listen(wave, 'pointermove', event => {
      if (!seek || seek.id !== event.pointerId) return;
      const dx = Math.abs(event.clientX - seek.x), dy = Math.abs(event.clientY - seek.y);
      if (!seek.active && dy > dx && dy > 8) { seek = null; return; }
      if (dx > 8 && !seek.active) { seek.active = true; wave.setPointerCapture(event.pointerId); }
      if (seek.active) commit(ratioAt(event));
    });
    listen(wave, 'pointerup', event => { if (seek?.id === event.pointerId) commit(ratioAt(event)); seek = null; });
    listen(wave, 'pointercancel', () => { seek = null; });
    listen(wave, 'keydown', event => {
      if (!source) return;
      const step = { ArrowLeft: -5, ArrowRight: 5 }[event.key];
      if (step && Number.isFinite(audio.duration)) { event.preventDefault(); commit((audio.currentTime + step) / audio.duration); }
      if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); commit(event.key === 'Home' ? 0 : 1); }
    });
    ['play', 'pause', 'timeupdate', 'loadedmetadata', 'ended'].forEach(type => listen(audio, type, () => {
      if (type === 'loadedmetadata' && player.pendingSeekRatio !== null) commit(player.pendingSeekRatio);
      if ((type === 'pause' || type === 'ended') && audioManager.current === player) audioManager.current = null;
      update();
    }));
    listen(audio, 'error', () => { if (source) message.textContent = 'No se pudo reproducir. Inténtalo otra vez.'; update(); });
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(player.paintFrame);
      player.paintFrame = requestAnimationFrame(paint);
    });
    observer.observe(wave);
    player.destroy = () => {
      ++attempt; events.abort(); observer.disconnect(); cancelAnimationFrame(player.paintFrame); audio.pause(); audio.removeAttribute('src'); audio.load();
      if (audioManager.current === player) audioManager.current = null;
      const index = audioManager.players.indexOf(player);
      if (index >= 0) audioManager.players.splice(index, 1);
    };
    audioManager.players.push(player);
    player.setSource(el.dataset.audio, el.dataset.peaks, el.dataset.title);
    return player;
  }
  class DetropolisMap extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.dataset.keyboard = 'false';
      this.signal = this.events.signal;
      this.frame = this.querySelector('.dt-street-map__viewport');
      this.world = this.querySelector('.dt-street-map__world');
      this.city = this.querySelector('.dt-street-map__city');
      this.initCityDetail();
      this.pins = [...this.querySelectorAll('.dt-street-map__pin')];
      this.templates = [...this.querySelectorAll('[data-pack-template]')];
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('[data-pack-content]');
      this.status = this.querySelector('.dt-street-map__status');
      this.entry = document.querySelector('detropolis-entry');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.layoutQuery = matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)');
      this.worldWidth = 1774;
      this.worldHeight = this.worldWidth / clamp(Number(this.dataset.cityAspect) || 2, .25, 5);
      this.world.style.height = `${this.worldHeight}px`;
      this.help = this.querySelector('.dt-street-map__help');
      this.prompt = this.querySelector('.dt-street-map__prompt');
      this.hasExplored ??= false;
      this.hasOpenedPack ??= false;
      this.help.hidden = this.hasExplored;
      this.prompt.hidden = this.hasOpenedPack;
      this.selectedPack = 0;
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.rail = this.querySelector('[data-card-track]');
      this.mainPlayer = streetPlayer(this.querySelector('[data-demo-slot] [data-street-player]'), this);
      this.samplePlayers = [];
      this.initGuide();
      this.initBonuses();
      this.cameras = {};
      this.pointers = new Map();
      this.route = 'west';
      this.active = -1;
      this.ready = false;
      this.expanded = false;
      this.camera = { x: 0, y: 0, scale: 1 };
      this.sizes = { width: 0, height: 0 };
      this.listen(this, 'click', this.handleClick.bind(this));
      this.listen(this.frame, 'pointerdown', this.pointerDown.bind(this));
      this.listen(this.frame, 'pointermove', this.pointerMove.bind(this));
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => this.listen(this.frame, type, this.pointerEnd.bind(this)));
      this.listen(this.frame, 'wheel', this.wheel.bind(this), { passive: false });
      this.listen(this.frame, 'keydown', this.mapKey.bind(this));
      this.listen(document, 'keydown', this.documentKey.bind(this));
      this.listen(document, 'fullscreenchange', this.fullscreenChange.bind(this));
      this.listen(this.layoutQuery, 'change', () => { this.syncStage(); this.fitEmbeddedHeight(); this.resize(); });
      this.listen(window, 'resize', () => this.fitEmbeddedHeight());
      if (window.visualViewport) this.listen(window.visualViewport, 'resize', () => this.fitEmbeddedHeight());
      this.listen(this.rail, 'scroll', () => this.railScroll(), { passive: true });
      this.listen(this.rail, 'pointerdown', () => { this.railProgrammatic = false; clearTimeout(this.railProgramTimer); });
      this.listen(document, 'keydown', event => { if (event.key === 'Tab') this.dataset.keyboard = 'true'; });
      this.listen(this, 'pointerdown', () => { this.dataset.keyboard = 'false'; }, { capture: true });
      this.listen(document, 'shopify:section:load', () => this.updateTargets());
      this.listen(document, 'detropolis:entry-selected', event => {
        if (event.target !== this.entry || this.dataset.designMode === 'true') return;
        this.enter(event.detail?.route);
      });
      this.listen(document, 'shopify:block:select', event => {
        const pin = event.target.closest?.('.dt-street-map__pin');
        if (pin && this.contains(pin)) this.openPack(Number(pin.dataset.pack));
      });
      this.listen(this.dialog, 'cancel', event => { event.preventDefault(); if (!this.checkoutBusy) this.closePack(); });
      this.listen(this.dialog, 'close', this.afterClose.bind(this));
      this.listen(this.dialog, 'click', event => {
        if (this.checkoutBusy || event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.closePack();
      });
      this.listen(this.city, 'load', () => this.cityReady());
      this.listen(this.city, 'error', () => this.cityError());
      this.observer = new ResizeObserver(() => this.resize());
      this.observer.observe(this.frame);
      this.railObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.fitEmbeddedHeight());
      });
      this.railObserver.observe(this.querySelector('.dt-street-map__rail'));
      this.updateTargets();
      this.syncStage();
      this.initPagePosition();
      this.fitEmbeddedHeight();
      if (this.entry && this.dataset.waitEntry === 'true' && this.dataset.designMode !== 'true' && !this.entry.dataset.selectedRoute) this.hidden = true;
      this.initSparkles();
      if (this.city.complete) this.city.naturalWidth ? this.cityReady() : this.cityError();
      else this.querySelector('.dt-street-map__loading').hidden = false;
      if (this.entry?.dataset.selectedRoute && this.dataset.designMode !== 'true') this.enter(this.entry.dataset.selectedRoute);
      else this.restoreEntrySession();
    }
    initSparkles() {
      this.destroySparkles();
      this.sparkleInView = !('IntersectionObserver' in window);
      const layer = document.createElement('div');
      layer.className = 'dt-street-map__sparkles';
      layer.setAttribute('aria-hidden','true');
      this.sparkleLayer = layer;
      this.sparklePoints = [[29,9],[37,24],[66,40],[83,26],[14,42],[73,66],[49,23],[45,66],[66,56],[12,22],[89,45],[15,70],[24,30],[54,34],[77,37],[58,63],[88,74],[36,49],[21,59],[61,16],[81,57],[48,79],[9,54],[32,75],[68,77],[93,31],[53,52],[41,37]];
      this.sparkles = [0,1].map(index => {
        const point = document.createElement('span');
        point.className = 'dt-street-map__sparkle';
        point.style.setProperty('--dtm-sparkle-duration',index ? '6.8s' : '5.8s');
        point.style.setProperty('--dtm-sparkle-delay',index ? '2.7s' : '0.25s');
        const pulse = document.createElement('span');
        pulse.className = 'dt-street-map__sparkle-pulse';
        point.append(pulse);
        layer.append(point);
        this.listen(pulse,'animationiteration',() => this.placeSparkle(point));
        return point;
      });
      this.world.append(layer);
      const sync = () => this.syncSparkles();
      this.listen(document,'visibilitychange',sync);
      this.listen(this.reduced,'change',sync);
      ['pointerdown','pointerup','pointercancel','lostpointercapture'].forEach(type => this.listen(this.frame,type,sync));
      if ('IntersectionObserver' in window) {
        this.sparkleIntersection = new IntersectionObserver(entries => {
          this.sparkleInView = entries.some(entry => entry.isIntersecting);
          this.syncSparkles();
        },{threshold:0});
        this.sparkleIntersection.observe(this.frame);
      }
      this.sparkleObserver = new MutationObserver(sync);
      this.sparkleObserver.observe(this,{attributes:true,attributeFilter:['hidden','inert']});
      this.sparkleObserver.observe(this.dialog,{attributes:true,attributeFilter:['open']});
      const guide = this.querySelector('[data-guide]');
      if (guide) this.sparkleObserver.observe(guide,{attributes:true,attributeFilter:['hidden']});
      this.syncSparkles();
    }
    syncSparkles() {
      if (!this.sparkleLayer) return;
      const enabled = !!(this.ready && !this.hidden && !this.inert && !this.entering && !document.hidden && !this.reduced.matches && this.sparkleInView && !this.dialog.open && !this.guideOpen && !this.pointers.size && (!this.entry || this.entered || this.dataset.designMode === 'true' || this.dataset.waitEntry !== 'true'));
      if (this.sparkleLayer.hasAttribute('data-active') === enabled) return;
      if (enabled) this.sparkles.forEach(point => this.placeSparkle(point));
      this.sparkleLayer.toggleAttribute('data-active',enabled);
    }
    placeSparkle(node) {
      const {x,y,scale} = this.camera;
      if (!this.sizes.width || !scale) { node.hidden = true; return; }
      const frame = this.frame.getBoundingClientRect();
      const labels = this.pins.filter(pin => pin.style.visibility !== 'hidden').map(pin => pin.getBoundingClientRect());
      const others = this.sparkles.filter(point => point !== node && !point.hidden && point.sparklePosition).map(point => point.sparklePosition);
      const candidates = this.sparklePoints.filter(([px,py]) => {
        const sx = x + px / 100 * this.worldWidth * scale;
        const sy = y + py / 100 * this.worldHeight * scale;
        if (sx < 28 || sx > this.sizes.width - 28 || sy < 40 || sy > this.sizes.height - 90) return false;
        const screenX = frame.left + this.frame.clientLeft + sx;
        const screenY = frame.top + this.frame.clientTop + sy;
        if (labels.some(box => screenX > box.left - 15 && screenX < box.right + 15 && screenY > box.top - 15 && screenY < box.bottom + 15)) return false;
        return others.every(([ox,oy]) => Math.hypot((px-ox)/100*this.worldWidth*scale,(py-oy)/100*this.worldHeight*scale) > 90);
      });
      node.hidden = !candidates.length;
      if (!candidates.length) return;
      const different = candidates.filter(point => point !== node.sparklePosition);
      const pool = different.length ? different : candidates;
      const point = pool[Math.floor(Math.random()*pool.length)];
      node.sparklePosition = point;
      node.style.left = point[0] + '%';
      node.style.top = point[1] + '%';
    }
    destroySparkles() {
      this.sparkleIntersection?.disconnect();
      this.sparkleObserver?.disconnect();
      this.sparkleLayer?.remove();
      this.sparkleLayer = null;
      this.sparkles = [];
    }
    listen(node, name, fn, options = {}) {
      node.addEventListener(name, fn, { ...options, signal: this.signal });
    }
    cityReady() {
      if (!this.events || this.ready) return;
      this.ready = true;
      this.querySelector('.dt-street-map__loading').hidden = true;
      this.querySelector('[data-retry]').hidden = true;
      this.resize();
      if (this.pendingRoute) {
        const route = this.pendingRoute;
        this.pendingRoute = null;
        this.enter(route);
      }
    }
    cityError() {
      if (this.ready) return;
      this.querySelector('.dt-street-map__loading').hidden = true;
      this.querySelector('[data-retry]').hidden = false;
      this.status.textContent = 'No se pudo cargar la ciudad. Puedes reintentarlo.';
      const entryStatus = this.entry?.querySelector('.dt-entry__status');
      if (entryStatus && this.pendingRoute) entryStatus.textContent = 'No se pudo cargar la ciudad. Pulsa de nuevo para reintentar.';
    }
    resize() {
      const r = { width: this.frame.clientWidth, height: this.frame.clientHeight };
      if (!r.width || !r.height) return;
      this.desktopLayout = this.layoutQuery.matches;
      const old = this.sizes;
      const center = old.width ? { x: (old.width / 2 - this.camera.x) / this.camera.scale, y: (old.height / 2 - this.camera.y) / this.camera.scale } : null;
      const oldCover = this.cover;
      this.stopAnimation();
      this.sizes = { width: r.width, height: r.height };
      this.fit = Math.min(r.width / this.worldWidth, r.height / this.worldHeight);
      this.cover = Math.max(r.width / this.worldWidth, r.height / this.worldHeight);
      this.maxScale = this.cover * (Number(this.dataset.maxZoom) || 1.8);
      if (!center) this.initialCamera(false);
      else {
        const overview = Math.abs(this.camera.scale - (this.oldFit || 0)) < .002;
        const scale = overview ? this.fit : clamp(this.camera.scale * this.cover / oldCover, this.fit, this.maxScale);
        this.camera = this.bound({ scale, x: r.width / 2 - center.x * scale, y: r.height / 2 - center.y * scale });
      }
      this.oldFit = this.fit;
      if (this.isEmbeddedTouch()) {
        const pin = this.pins[this.selectedPack];
        this.camera = this.bound({ scale: r.height / this.worldHeight, x: r.width / 2 - Number(pin?.dataset.x || 50) / 100 * this.worldWidth * (r.height / this.worldHeight), y: 0 });
      }
      this.render();
      this.centerCard(false);
      if (this.guideOpen) this.positionGuide();
    }
    bound(camera) {
      const { width, height } = this.sizes;
      const scale = clamp(camera.scale, this.fit, this.maxScale);
      const w = this.worldWidth * scale, h = this.worldHeight * scale;
      return { scale, x: w <= width ? (width - w) / 2 : clamp(camera.x, width - w, 0), y: h <= height ? (height - h) / 2 : clamp(camera.y, height - h, 0) };
    }
    initialCamera(animate = false) {
      if (!this.sizes.width) return;
      if (this.desktopLayout) this.setCamera({ scale: this.fit, x: 0, y: 0 }, animate);
      else {
        const focus = this.route === 'west' ? { x: .28, y: .47 } : { x: .60, y: .44 };
        this.setCamera({ scale: this.cover, x: this.sizes.width / 2 - focus.x * this.worldWidth * this.cover, y: this.sizes.height / 2 - focus.y * this.worldHeight * this.cover }, animate);
      }
    }
    setCamera(target, animate = false) {
      this.stopAnimation();
      const end = this.bound(target);
      if (!animate || this.reduced.matches) {
        this.camera = end;
        this.render();
        return;
      }
      const start = { ...this.camera }, startTime = performance.now();
      const tick = now => {
        const p = clamp((now - startTime) / 300, 0, 1);
        const t = 1 - (1 - p) ** 3;
        this.camera = { x: start.x + (end.x - start.x) * t, y: start.y + (end.y - start.y) * t, scale: start.scale + (end.scale - start.scale) * t };
        this.renderNow();
        this.animation = p < 1 ? requestAnimationFrame(tick) : 0;
      };
      this.animation = requestAnimationFrame(tick);
    }
    stopAnimation() {
      cancelAnimationFrame(this.animation);
      this.animation = 0;
    }
    render() {
      if (this.paint) return;
      this.paint = requestAnimationFrame(() => { this.paint = 0; this.renderNow(); });
    }
    renderNow() {
      if (!this.sizes.width) return;
      const { x, y, scale } = this.camera;
      this.world.style.transform = `translate3d(${x}px,${y}px,0) scale(${scale})`;
      if (this.sparkleLayer) {
        const inverse = (1 / scale).toFixed(5);
        if (this.sparkleLayer.style.getPropertyValue('--dtm-sparkle-scale') !== inverse) this.sparkleLayer.style.setProperty('--dtm-sparkle-scale',inverse);
        this.syncSparkles();
      }
      this.pins.forEach(pin => {
        const px = x + Number(pin.dataset.x) / 100 * this.worldWidth * scale;
        const py = y + Number(pin.dataset.y) / 100 * this.worldHeight * scale;
        const drawY = Math.max(48, py);
        const left = pin.classList.contains('dt-street-map__pin--left');
        pin.style.transform = `translate3d(${px}px,${drawY}px,0) translate(${left ? 'calc(-100% + 20px)' : '-20px'},-100%)`;
        const visible = px >= 12 && px <= this.sizes.width - 12 && py >= 0 && py <= this.sizes.height - 12;
        pin.style.visibility = visible ? '' : 'hidden';
        pin.tabIndex = visible ? 0 : -1;
      });
      this.frame.classList.toggle('is-overview', scale < this.cover * .78);
      this.querySelector('[data-zoom="1"]').disabled = scale >= this.maxScale - .001;
      this.querySelector('[data-zoom="-1"]').disabled = scale <= this.fit + .001;
      this.scheduleCityDetail();
    }
    initCityDetail() {
      clearTimeout(this.detailTimer);
      this.detailTimer = 0;
      this.detailPending = '';
      this.detailImage = null;
      this.detailFailures = new Map();
      this.detailWidth = Number(this.city.dataset.loadedWidth || this.city.dataset.initialWidth) || 1100;
      this.detailLevels = [
        { src:this.city.dataset.mediumSrc, width:Number(this.city.dataset.mediumWidth) || 2400 },
        { src:this.city.dataset.detailSrc, width:Number(this.city.dataset.detailWidth) || 3548 }
      ].filter(level => level.src && level.width > this.detailWidth)
        .sort((a,b) => a.width - b.width);
    }
    cityDetailTarget() {
      const connection = navigator.connection;
      const slow = ['slow-2g','2g'].includes(connection?.effectiveType);
      const limited = connection?.saveData || connection?.effectiveType === '3g';
      const density = Math.min(Math.max(window.devicePixelRatio || 1,1),2);
      const demand = this.worldWidth * this.camera.scale * density;
      const levels = this.detailLevels.filter(level => !slow && (!limited || level.width <= 2400));
      if (demand <= this.detailWidth * 1.12) return null;
      return levels.find(level => level.width > this.detailWidth && level.width * 1.12 >= demand)
        || levels.filter(level => level.width > this.detailWidth).at(-1) || null;
    }
    scheduleCityDetail() {
      if (!this.ready || !this.isConnected || this.signal?.aborted || this.detailImage) return;
      const target = this.cityDetailTarget();
      if (!target) {
        clearTimeout(this.detailTimer);
        this.detailTimer = 0;
        this.detailPending = '';
        return;
      }
      const failed = this.detailFailures.get(target.src);
      if (failed && (failed.count >= 2 || Date.now() - failed.time < 5000)) return;
      if (this.detailPending === target.src && this.detailTimer) return;
      clearTimeout(this.detailTimer);
      this.detailPending = target.src;
      this.detailTimer = setTimeout(() => {
        this.detailTimer = 0;
        this.detailPending = '';
        this.loadDetail();
      },180);
    }
    loadDetail() {
      if (!this.ready || !this.isConnected || this.signal?.aborted || this.detailImage) return;
      const target = this.cityDetailTarget();
      if (!target) return;
      const failed = this.detailFailures.get(target.src);
      if (failed && (failed.count >= 2 || Date.now() - failed.time < 5000)) return;
      const image = new Image();
      const signal = this.signal;
      const city = this.city;
      this.detailImage = image;
      image.decoding = 'async';
      const valid = () => !signal.aborted && this.isConnected && this.city === city && this.detailImage === image;
      const fail = () => {
        if (!valid()) return;
        this.detailFailures.set(target.src,{ count:(failed?.count || 0) + 1, time:Date.now() });
        this.detailImage = null;
        image.onload = null;
        image.onerror = null;
      };
      image.onload = async () => {
        try { if (image.decode) await image.decode(); } catch (_) { fail(); return; }
        if (!valid()) return;
        if (target.width > this.detailWidth) {
          city.src = target.src;
          this.detailWidth = target.width;
          city.dataset.loadedWidth = String(target.width);
        }
        this.detailImage = null;
        image.onload = null;
        image.onerror = null;
        this.scheduleCityDetail();
      };
      image.onerror = fail;
      image.src = target.src;
    }
    zoom(factor, point = { x: this.sizes.width / 2, y: this.sizes.height / 2 }, animate = true) {
      const old = this.camera;
      const scale = clamp(old.scale * factor, this.fit, this.maxScale);
      if (Math.abs(scale - old.scale) > .0001) this.dismissHelp();
      this.setCamera({ scale, x: point.x - (point.x - old.x) * scale / old.scale, y: point.y - (point.y - old.y) * scale / old.scale }, animate);
    }
    fitCity() {
      this.dismissHelp();
      this.setCamera({ scale: this.fit, x: 0, y: 0 }, true);
      this.status.textContent = 'Vista de la ciudad completa.';
    }
    centerPack(index, animate = true) {
      const pin = this.pins[index];
      if (!pin || !this.sizes.width) return;
      const scale = this.isEmbeddedTouch() ? this.sizes.height / this.worldHeight : this.camera.scale;
      this.setCamera({ scale, x: this.sizes.width / 2 - Number(pin.dataset.x) / 100 * this.worldWidth * scale, y: this.isEmbeddedTouch() ? 0 : this.sizes.height / 2 - Number(pin.dataset.y) / 100 * this.worldHeight * scale }, animate);
    }
    localPoint(event) {
      const r = this.frame.getBoundingClientRect();
      return { x: event.clientX - r.left - this.frame.clientLeft, y: event.clientY - r.top - this.frame.clientTop };
    }
    pointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (this.guideOpen || event.target.closest('.dt-street-map__controls,[data-retry]')) return;
      if (this.isEmbeddedTouch() && this.pointers.size) { this.clearPointers(); return; }
      this.stopAnimation();
      const point = this.localPoint(event);
      this.pointers.set(event.pointerId, point);
      if (this.pointers.size === 1) {
        this.drag = { pointer: event.pointerId, start: point, camera: { ...this.camera }, active: false, type: event.pointerType };
        this.suppressClick = false;
      } else if (this.pointers.size === 2) {
        const [a,b] = [...this.pointers.values()];
        this.pinch = { distance: Math.hypot(a.x-b.x,a.y-b.y), middle: { x:(a.x+b.x)/2, y:(a.y+b.y)/2 }, camera: { ...this.camera } };
        this.suppressClick = true;
        this.pointers.forEach((_,id) => { try { this.frame.setPointerCapture(id); } catch (_) { } });
      }
    }
    pointerMove(event) {
      if (!this.pointers.has(event.pointerId)) return;
      const point = this.localPoint(event);
      this.pointers.set(event.pointerId, point);
      if (this.pointers.size >= 2 && this.pinch) {
        const [a,b] = [...this.pointers.values()], start = this.pinch;
        const distance = Math.hypot(a.x-b.x,a.y-b.y);
        const middle = { x:(a.x+b.x)/2, y:(a.y+b.y)/2 };
        if (Math.abs(distance - start.distance) > 4 || Math.hypot(middle.x - start.middle.x, middle.y - start.middle.y) > 4) this.dismissHelp();
        const scale = clamp(start.camera.scale * distance / Math.max(1,start.distance),this.fit,this.maxScale);
        this.camera = this.bound({ scale, x:middle.x-(start.middle.x-start.camera.x)*scale/start.camera.scale, y:middle.y-(start.middle.y-start.camera.y)*scale/start.camera.scale });
        this.render();
        return;
      }
      const drag = this.drag;
      if (!drag || drag.pointer !== event.pointerId) return;
      const dx = point.x-drag.start.x, dy = point.y-drag.start.y;
      if (!drag.active) {
        if (Math.hypot(dx,dy) < 8) return;
        if (this.isEmbeddedTouch() && Math.abs(dy) > Math.abs(dx)) return;
        drag.active = true;
        this.dismissHelp();
        this.suppressClick = true;
        this.frame.setPointerCapture(event.pointerId);
        this.frame.classList.add('is-dragging');
      }
      this.camera = this.bound({ ...drag.camera, x:drag.camera.x+dx, y:this.isEmbeddedTouch() ? drag.camera.y : drag.camera.y+dy });
      this.render();
    }
    pointerEnd(event) {
      if (event.type === 'lostpointercapture' && event.target !== this.frame) return;
      this.pointers.delete(event.pointerId);
      if (this.pointers.size < 2) this.pinch = null;
      if (!this.pointers.size) {
        this.drag = null;
        this.frame.classList.remove('is-dragging');
      } else {
        const [id,point] = [...this.pointers.entries()][0];
        this.drag = { pointer:id, start:point, camera:{ ...this.camera }, active:true, type:event.pointerType };
      }
    }
    wheel(event) {
      if (this.isEmbeddedTouch() || this.guideOpen || (!event.ctrlKey && !event.metaKey)) return;
      event.preventDefault();
      this.zoom(Math.exp(-event.deltaY*.005),this.localPoint(event),false);
    }
    mapKey(event) {
      if (event.target !== this.frame || event.ctrlKey || event.metaKey || event.altKey) return;
      if (this.isEmbeddedTouch() && !['ArrowLeft','ArrowRight','Home'].includes(event.key)) return;
      const movement = { ArrowLeft:[70,0], ArrowRight:[-70,0], ArrowUp:[0,70], ArrowDown:[0,-70] }[event.key];
      if (movement) {
        event.preventDefault();
        this.dismissHelp();
        this.setCamera({ ...this.camera, x:this.camera.x+movement[0], y:this.camera.y+movement[1] },false);
      } else if (['+','=','-','Home'].includes(event.key)) {
        event.preventDefault();
        event.key === 'Home' ? this.fitCity() : this.zoom(event.key === '-' ? 1/1.25 : 1.25);
      }
    }
    async handleClick(event) {
      const button = event.target.closest('button,a[data-page-target]');
      if (!button || !this.contains(button)) return;
      if (button.matches('.dt-street-map__pin') && this.suppressClick) { this.suppressClick=false; event.preventDefault(); return; }
      if (button.hasAttribute('data-vault-item')) return this.chooseVault(button);
      if (button.hasAttribute('data-vault-save')) return this.saveVault();
      if (button.hasAttribute('data-bunny-play')) return this.playBonusVideo(button);
      if (button.hasAttribute('data-street-purchase-link')) { event.preventDefault(); return this.openPurchase(button); }
      if (this.checkoutBusy) return;
      if (button.hasAttribute('data-pack')) return this.openPack(Number(button.dataset.pack));
      if (button.hasAttribute('data-zoom')) return this.zoom(Number(button.dataset.zoom)>0 ? 1.25 : 1/1.25);
      if (button.hasAttribute('data-fit')) return this.fitCity();
      if (button.hasAttribute('data-help')) return this.showGuide();
      if (button.hasAttribute('data-card-previous')) return this.selectPack(this.selectedPack - 1);
      if (button.hasAttribute('data-card-next')) return this.selectPack(this.selectedPack + 1);
      if (button.hasAttribute('data-expand')) return this.toggleExpanded();
      if (button.hasAttribute('data-close')) return this.closePack();
      if (button.hasAttribute('data-next')) return this.openPack((this.pendingPackIndex ?? this.active)+1, 1);
      if (button.hasAttribute('data-previous')) return this.openPack((this.pendingPackIndex ?? this.active)-1, -1);
      if (button.hasAttribute('data-all-packs')) {
        const list=this.querySelector('[data-dialog-list]');
        list.hidden=!list.hidden;
        button.setAttribute('aria-expanded',String(!list.hidden));
        if (!list.hidden) list.querySelector('button')?.focus();
      }
      if (button.hasAttribute('data-change-entry')) return this.changeEntry();
      if (button.hasAttribute('data-retry')) {
        this.querySelector('[data-retry]').hidden=true;
        this.querySelector('.dt-street-map__loading').hidden=false;
        this.city.src=this.city.getAttribute('src');
      }
      if (button.hasAttribute('data-page-target')) {
        event.preventDefault();
        const target=this.targetFor(button.dataset.pageTarget);
        if (target) { if (this.expanded) await this.exitExpanded(); target.scrollIntoView({ behavior:this.reduced.matches?'instant':'smooth',block:'start' }); }
        else this.status.textContent='Esta sección se conectará cuando esté instalada en la página.';
      }
    }
    async packMotionFor(node, frames, duration) {
      this.packMotion?.cancel();
      if (this.reduced.matches || !node?.animate) return;
      const motion = node.animate(frames, { duration, easing:'cubic-bezier(.2,.7,.25,1)', fill:'both' });
      this.packMotion = motion;
      try { await motion.finished; } catch (_) { }
      motion.cancel();
      if (this.packMotion === motion) this.packMotion = null;
    }
    async openPack(index, direction = 0) {
      if (!Number.isInteger(index) || !this.templates[index] || !this.ready || this.checkoutBusy) return;
      const sequence = this.packSequence = (this.packSequence || 0) + 1;
      const wasOpen = this.dialog.open;
      this.pendingPackIndex = index;
      this.dialog.classList.remove('is-closing');
      this.samplePlayers.forEach(player => player.pause());
      this.stopBonusVideo();
      if (wasOpen) await this.packMotionFor(this.content, [{ opacity:1, transform:'translateX(0)' }, { opacity:0, transform:`translateX(${-direction * 8}px)` }], 90);
      if (sequence !== this.packSequence || !this.isConnected) return;
      this.renderPack(index);
      this.pendingPackIndex = null;
      const target = wasOpen ? this.content : this.dialog;
      await this.packMotionFor(target, [{ opacity:0, transform:wasOpen ? `translateX(${direction * 8}px)` : 'translateY(8px)' }, { opacity:1, transform:'translate(0,0)' }], wasOpen ? 150 : 180);
    }
    async closePack({ force = false, returnFocus = true } = {}) {
      if ((!force && this.checkoutBusy) || !this.dialog.open) return;
      if (this.closingPack) return this.closingPack;
      const sequence = this.packSequence = (this.packSequence || 0) + 1;
      this.pendingPackIndex = null;
      this.skipPackReturnFocus = !returnFocus;
      this.samplePlayers.forEach(player => player.pause());
      this.stopBonusVideo();
      this.dialog.classList.add('is-closing');
      const closing = (async () => {
        await this.packMotionFor(this.dialog, [{ opacity:1, transform:'translateY(0)' }, { opacity:0, transform:'translateY(6px)' }], 140);
        if (sequence !== this.packSequence || !this.dialog.open) return;
        await new Promise(resolve => {
          this.dialog.addEventListener('close', resolve, { once:true });
          this.dialog.close();
        });
      })();
      this.closingPack = closing;
      try { await closing; } finally { if (this.closingPack === closing) this.closingPack = null; }
    }
    renderPack(index) {
      if (!Number.isInteger(index) || !this.templates[index] || !this.ready) return;
      this.hasOpenedPack = true;
      this.prompt.hidden = true;
      if (this.checkoutBusy) return;
      this.resetBonusShell();
      const previous=this.active;
      this.dispatchEvent(new CustomEvent('detropolis:pack-will-change',{bubbles:true,detail:{previous,index,root:this.content}}));
      this.samplePlayers.forEach(player => player.destroy());
      this.samplePlayers = [];
      if (this.guideOpen) this.finishGuide();
      this.active=index;
      const packSource = this.templates[index].content.cloneNode(true);
      const bonusKind = this.templates[index].dataset.bonusKind;
      this.content.replaceChildren(packSource);
      if (bonusKind === 'vault' || bonusKind === 'documentary') this.mountBonus(bonusKind, this.content.cloneNode(true));
      this.querySelector('[data-previous]').disabled=index===0;
      this.querySelector('[data-next]').disabled=index===this.templates.length-1;
      this.querySelector('[data-pack-count]').textContent=`${String(index+1).padStart(2,'0')} / ${this.templates.length}`;
      this.querySelector('[data-dialog-list]').hidden=true;
      this.querySelector('[data-all-packs]').setAttribute('aria-expanded','false');
      this.pins.forEach((pin,i)=>{ if(i===index) pin.setAttribute('aria-current','true'); else pin.removeAttribute('aria-current'); });
      const pin = this.pins[index];
      const automaticColor = pin.classList.contains('dt-street-map__pin--bonus') ? 'var(--dtm-gold)' : (this.route === 'detroit' ? 'var(--dtm-detroit)' : 'var(--dtm-west)');
      const packColor = pin.style.getPropertyValue('--dtm-pack-accent').trim() || pin.style.getPropertyValue('--dtm-pin').trim() || automaticColor;
      this.dialog.style.setProperty('--dtm-accent', packColor);
      this.selectPack(index);
      renderPackHighlights(this.content);
      this.samplePlayers = [...this.content.querySelectorAll('[data-street-player]')].map(el => streetPlayer(el, this));
      if (!this.dialog.open) {
        this.unlockDialog=lockScroll();
        this.dialog.showModal();
      }
      this.refreshDocumentaryPreview?.();
      this.dialog.scrollTop=0;
      this.content.querySelector('h3')?.focus({preventScroll:true});
      this.dispatchEvent(new CustomEvent('detropolis:pack-opened',{bubbles:true,detail:{index,root:this.content}}));
    }
    afterClose() {
      this.packSequence = (this.packSequence || 0) + 1;
      this.packMotion?.cancel();
      this.dialog.classList.remove('is-closing');
      this.pendingPackIndex = null;
      this.stopBonusVideo();
      this.samplePlayers.forEach(player => player.destroy());
      this.samplePlayers = [];
      this.unlockDialog?.();
      this.unlockDialog=null;
      this.dispatchEvent(new CustomEvent('detropolis:pack-closed',{bubbles:true,detail:{index:this.active,root:this.content}}));
      if (!this.skipPackReturnFocus) this.pins[this.active]?.focus({preventScroll:true});
      this.skipPackReturnFocus = false;
    }
    initBonuses() {
      try { this.commerce = JSON.parse(this.querySelector('[data-street-commerce]')?.textContent || '{}'); } catch (_) { this.commerce = {}; }
      const variants = this.commerce.variants || [];
      this.withVault = variants.find(v => v.options?.includes('Con Baúl'));
      this.withoutVault = variants.find(v => v.options?.includes('Sin Baúl'));
      this.catalog = [...this.querySelector('[data-vault-template]')?.content.querySelectorAll('[data-vault-item]') || []].map(node => ({ id:String(node.dataset.variantId), productId:String(node.dataset.productId), handle:node.dataset.handle, title:node.dataset.title, available:node.dataset.available === 'true' }));
      this.vaultKey = `detropolis:vault:v1:${this.dataset.pageKey}`;
      this.vaultSelection = { mode:'unset', ids:[] };
      try {
        const stored = JSON.parse(sessionStorage.getItem(this.vaultKey));
        if (stored && ['with','without'].includes(stored.mode)) this.vaultSelection = { mode:stored.mode, ids:[...new Set(stored.ids || [])].filter(id => this.catalog.some(item => item.id === id)).slice(0,4) };
      } catch (_) { }
      this.selectWithoutVaultIfSoldOut();
      this.listen(this, 'change', event => {
        if (event.target.matches('[data-vault-skip]')) {
          this.vaultDraft.mode = event.target.checked ? 'without' : 'with';
          this.paintVault();
        }
      });
      this.listen(document, 'click', event => {
        const trigger = event.target.closest('[data-detropolis-purchase]');
        if (!trigger || (trigger.dataset.detropolisPurchase && trigger.dataset.detropolisPurchase !== String(this.commerce.productId))) return;
        event.preventDefault(); this.openPurchase(trigger);
      });
      this.listen(document, 'detropolis:purchase', event => {
        if (event.detail?.productId && String(event.detail.productId) !== String(this.commerce.productId)) return;
        this.openPurchase();
      });
    }
    vaultIndex() { return this.templates.findIndex(t => t.dataset.bonusKind === 'vault'); }
    vaultAvailable() { return !!this.withVault?.available; }

    selectWithoutVaultIfSoldOut() {
      if (
        !this.withVault ||
        this.withVault.available ||
        !this.withoutVault?.available
      ) return false;

      if (
        this.vaultSelection.mode === 'without' &&
        !this.vaultSelection.ids.length
      ) return false;

      this.vaultSelection = { mode:'without', ids:[] };

      try {
        sessionStorage.setItem(
          this.vaultKey,
          JSON.stringify(this.vaultSelection)
        );
      } catch (_) { }

      this.dispatchEvent(new CustomEvent('detropolis:vault-updated', {
        bubbles:true,
        detail:{
          productId:this.commerce.productId,
          mode:'without',
          bundles:[]
        }
      }));

      return true;
    }
    mountBonus(kind, source) {
      const template = this.querySelector(kind === 'vault' ? '[data-vault-template]' : '[data-documentary-template]');
      if (!template) return;
      const copy = source.querySelector('template[data-bonus-copy]');
      const description = source.querySelector('.dt-street-map__description');
      this.content.replaceChildren(template.content.cloneNode(true));
      if (copy) {
        this.content.querySelectorAll('[data-bonus-field]').forEach(destination => {
          const field = copy.content.querySelector(`[data-bonus-field="${destination.dataset.bonusField}"]`);
          if (!field) return;
          destination.replaceChildren(...[...field.childNodes].map(node => node.cloneNode(true)));
          destination.hidden = !destination.textContent.trim();
        });
      } else {
        const destination = this.content.querySelector('[data-bonus-description]');
        const hasDescription = description && !/^Descubre .+ en Street Edition\.$/.test(description.textContent.trim());
        if (hasDescription) destination.replaceChildren(...[...description.childNodes].map(node => node.cloneNode(true)));
        else if (kind === 'documentary') destination.textContent = 'Entra al proceso detrás de Street Edition: las ideas, las decisiones y los sonidos que le dieron vida a esta ciudad.';
      }
      const wrapper = this.content.querySelector('[data-bunny-video]');
      if (wrapper) wrapper.dataset.playLabel = wrapper.querySelector('[data-bunny-play] strong')?.textContent.trim() || 'Ver el tráiler';
      this.dialog.classList.toggle('is-vault', kind === 'vault');
      this.dialog.classList.toggle('is-documentary', kind === 'documentary');
      if (kind === 'documentary') this.mountDocumentary();
      if (kind === 'vault') {
        this.vaultDraft = { mode:this.vaultSelection.mode === 'without' ? 'without' : 'with', ids:[...this.vaultSelection.ids] };
        this.paintVault();
      }
    }
    paintVault() {
      const root = this.content.querySelector('[data-vault]');
      if (!root) return;
      const soldOut = !this.vaultAvailable();
      const skip = root.querySelector('[data-vault-skip]');
      if (soldOut) this.vaultDraft.mode = 'without';
      skip.checked = this.vaultDraft.mode === 'without';
      const selected = skip.checked ? [] : this.vaultDraft.ids;
      root.querySelector('[data-vault-counter]').textContent = `${selected.length} de 4 seleccionados`;
      const stock = root.querySelector('[data-vault-stock]');
      if (!this.withVault) stock.textContent = 'El Baúl aún no está disponible para comprar.';
      else if (soldOut) stock.textContent = 'Baúl agotado. Puedes seguir explorando el catálogo y comprar Street Edition sin Baúl.';
      else if (this.withVault.tracked && this.withVault.policy === 'deny') stock.textContent = `Quedan ${Math.max(0, this.withVault.quantity)} accesos al Baúl.`;
      else stock.textContent = 'Disponible con la opción Con Baúl.';
      root.querySelectorAll('[data-vault-item]').forEach(button => {
        const item = this.catalog.find(p => p.id === button.dataset.variantId);
        const active = selected.includes(button.dataset.variantId);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = soldOut || skip.checked || (!item?.available && !active) || (selected.length >= 4 && !active);
      });
      const unavailable = selected.some(id => !this.catalog.find(item => item.id === id)?.available);
      root.querySelector('[data-vault-save]').disabled = !skip.checked && (!selected.length || unavailable);
      root.querySelector('[data-vault-feedback]').classList.remove('is-required');
      root.querySelector('[data-vault-feedback]').textContent = skip.checked ? 'Street Edition sin Baúl. El documental y los demás packs siguen incluidos.' : unavailable ? 'Un bundle seleccionado ya no está disponible. Desmárcalo para elegir otro.' : selected.length === 4 ? 'Selección completa. Desmarca un bundle si quieres cambiarlo.' : 'Elige los bundles de 2026 que quieres llevarte.';
    }
    chooseVault(button) {
      if (this.checkoutBusy) return;
      const id = button.dataset.variantId;
      const ids = this.vaultDraft.ids;
      if (ids.includes(id)) this.vaultDraft.ids = ids.filter(item => item !== id);
      else if (ids.length < 4 && this.vaultAvailable()) ids.push(id);
      this.paintVault();
    }
    async saveVault() {
      if (this.checkoutBusy) return;
      const draft = this.vaultDraft;
      if (draft.mode !== 'without' && (!draft.ids.length || draft.ids.length > 4 || !this.vaultAvailable())) return;
      this.vaultSelection = { mode:draft.mode, ids:draft.mode === 'without' ? [] : [...draft.ids] };
      try { sessionStorage.setItem(this.vaultKey, JSON.stringify(this.vaultSelection)); } catch (_) { }
      this.status.textContent = draft.mode === 'without' ? 'Guardado: continuar sin Baúl.' : `Guardado: ${draft.ids.length} bundles del Baúl. Se añadirán al comprar.`;
      this.dispatchEvent(new CustomEvent('detropolis:vault-updated', { bubbles:true, detail:{ productId:this.commerce.productId, mode:this.vaultSelection.mode, bundles:this.catalog.filter(item => this.vaultSelection.ids.includes(item.id)).map(({id,title}) => ({id,title})) } }));
      await this.closePack();
    }
    mountDocumentary() {
      const wrapper = this.content.querySelector('[data-bunny-video]');
      if (!wrapper) return;
      const video = wrapper.querySelector('[data-documentary-teaser]');
      const events = new AbortController();
      this.documentaryEvents = events;
      wrapper.dataset.videoState = 'idle';
      if (!video) return;
      const connection = navigator.connection;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = true;
      this.refreshDocumentaryPreview = () => {
        const allowed = visible && !document.hidden && !motion.matches && !connection?.saveData && wrapper.dataset.videoState === 'idle' && this.dialog.open;
        if (!allowed) { video.pause(); return; }
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.muted = true;
        video.defaultMuted = true;
        const promise = video.play();
        promise?.catch(() => wrapper.classList.remove('has-teaser-frame'));
      };
      video.addEventListener('playing', () => wrapper.classList.add('has-teaser-frame'), { signal:events.signal });
      video.addEventListener('error', () => wrapper.classList.remove('has-teaser-frame'), { signal:events.signal });
      document.addEventListener('visibilitychange', this.refreshDocumentaryPreview, { signal:events.signal });
      motion.addEventListener('change', this.refreshDocumentaryPreview, { signal:events.signal });
      if ('IntersectionObserver' in window) {
        this.documentaryObserver = new IntersectionObserver(entries => {
          visible = entries[0]?.isIntersecting === true;
          this.refreshDocumentaryPreview?.();
        }, { threshold:0.05 });
        this.documentaryObserver.observe(wrapper);
      }
      this.refreshDocumentaryPreview();
    }
    stopBonusVideo({ keepPreview = false } = {}) {
      this.bunnySession?.destroy();
      this.bunnySession = null;
      this.content?.querySelectorAll('[data-bunny-frame]').forEach(iframe => iframe.remove());
      const wrapper = this.content?.querySelector('[data-bunny-video]');
      if (wrapper) {
        wrapper.dataset.videoState = 'idle';
        wrapper.removeAttribute('aria-busy');
        const button = wrapper.querySelector('[data-bunny-play]');
        if (button) {
          button.hidden = false;
          button.disabled = false;
          button.querySelector('strong').textContent = wrapper.dataset.playLabel || 'Ver el tráiler';
        }
        wrapper.querySelector('[data-bunny-status]').textContent = '';
      }
      if (keepPreview) { this.refreshDocumentaryPreview?.(); return; }
      this.documentaryEvents?.abort();
      this.documentaryEvents = null;
      this.documentaryObserver?.disconnect();
      this.documentaryObserver = null;
      this.refreshDocumentaryPreview = null;
      wrapper?.classList.remove('has-teaser-frame');
      wrapper?.querySelectorAll('[data-documentary-teaser]').forEach(video => {
        video.pause();
        if (video.getAttribute('src')) { video.removeAttribute('src'); video.load(); }
      });
    }
    playBonusVideo(button) {
      const wrapper = button.closest('[data-bunny-video]');
      const message = this.content.querySelector('[data-video-message]');
      if (!wrapper || !message || button.disabled) return;
      let url;
      try {
        url = new URL(wrapper.dataset.bunnyUrl);
        if (url.protocol !== 'https:' || !['iframe.mediadelivery.net','player.mediadelivery.net'].includes(url.hostname) || !/^\/embed\/\d+\/[a-zA-Z0-9-]+\/?$/.test(url.pathname)) throw new Error();
      } catch (_) { message.textContent = 'No se pudo abrir el tráiler. Revisa el enlace de incrustación de Bunny.'; return; }
      if (wrapper.querySelector('iframe')) { this.bunnySession?.play(); return; }
      audioManager.players.forEach(player => {
        if (typeof player.pause === 'function') player.pause();
        else { player.audio?.pause(); cancelAnimationFrame(player.raf); if (player.button) { player.button.textContent = '▶'; player.button.setAttribute('aria-label', 'Reproducir audio'); } }
      });
      audioManager.current?.pause?.();
      this.mainPlayer.pause();
      wrapper.querySelector('[data-documentary-teaser]')?.pause();
      url.searchParams.set('autoplay','true');
      url.searchParams.set('muted','false');
      url.searchParams.set('loop','false');
      url.searchParams.set('playsinline','true');
      url.searchParams.set('preload','true');
      const iframe = document.createElement('iframe');
      iframe.dataset.bunnyFrame = '';
      iframe.title = 'Tráiler de Cómo hicimos Detropolis: Street Edition';
      iframe.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      const events = new AbortController();
      const status = wrapper.querySelector('[data-bunny-status]');
      const session = {
        ready:false, shown:false, lastTime:null, timer:0,
        send:(method, value, listener) => {
          const payload = { context:'player.js', version:'0.0.11', method };
          if (value !== undefined) payload.value = value;
          if (listener !== undefined) payload.listener = listener;
          iframe.contentWindow?.postMessage(JSON.stringify(payload), url.origin);
        },
        destroy:() => { clearTimeout(session.timer); events.abort(); iframe.remove(); },
        play:() => {
          if (!session.ready) return;
          clearTimeout(session.timer);
          wrapper.dataset.videoState = 'loading';
          wrapper.setAttribute('aria-busy','true');
          status.textContent = 'Preparando el tráiler…';
          button.disabled = true;
          session.send('play');
          session.timer = setTimeout(offerPlayback, 12000);
        }
      };
      const offerPlayback = () => {
        if (this.bunnySession !== session || session.shown) return;
        wrapper.dataset.videoState = 'waiting';
        wrapper.removeAttribute('aria-busy');
        status.textContent = session.ready ? 'Pulsa para iniciar el tráiler.' : 'El tráiler tarda en cargar. Puedes reintentar.';
        button.disabled = false;
        button.querySelector('strong').textContent = session.ready ? 'Reproducir tráiler' : 'Reintentar';
        if (!session.ready) { session.destroy(); if (this.bunnySession === session) this.bunnySession = null; }
      };
      const reveal = () => {
        if (this.bunnySession !== session || session.shown) return;
        session.shown = true;
        clearTimeout(session.timer);
        wrapper.dataset.videoState = 'playing';
        wrapper.removeAttribute('aria-busy');
        status.textContent = '';
        button.disabled = false;
        button.hidden = true;
        iframe.focus({ preventScroll:true });
      };
      const subscribe = () => {
        ['ready','play','pause','timeupdate','ended','error'].forEach(name => session.send('addEventListener', name, `dtm-${name}`));
      };
      window.addEventListener('message', event => {
        if (event.source !== iframe.contentWindow || event.origin !== url.origin || this.bunnySession !== session) return;
        let data;
        try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch (_) { return; }
        if (!data || data.context !== 'player.js') return;
        if (data.event === 'ready' && !session.ready) {
          session.ready = true;
          subscribe();
        } else if (data.event === 'timeupdate') {
          let value = data.value;
          try { if (typeof value === 'string') value = JSON.parse(value); } catch (_) { return; }
          const seconds = Number(value?.seconds);
          if (!Number.isFinite(seconds)) return;
          if (session.lastTime !== null && seconds > session.lastTime + 0.01) reveal();
          session.lastTime = seconds;
        } else if (data.event === 'pause' && !session.shown) {
          clearTimeout(session.timer);
          offerPlayback();
        } else if (data.event === 'error') {
          session.destroy();
          this.bunnySession = null;
          wrapper.dataset.videoState = 'error';
          wrapper.removeAttribute('aria-busy');
          status.textContent = 'No se pudo cargar el tráiler. Intenta nuevamente.';
          button.disabled = false;
          button.hidden = false;
          button.querySelector('strong').textContent = 'Reintentar';
        }
      }, { signal:events.signal });
      iframe.addEventListener('load', subscribe, { signal:events.signal });
      iframe.addEventListener('error', offerPlayback, { signal:events.signal });
      this.bunnySession = session;
      wrapper.dataset.videoState = 'loading';
      wrapper.setAttribute('aria-busy','true');
      status.textContent = 'Preparando el tráiler…';
      button.disabled = true;
      button.querySelector('strong').textContent = 'Cargando tráiler';
      iframe.src = url.href;
      wrapper.append(iframe);
      session.timer = setTimeout(offerPlayback, 12000);
      message.textContent = 'Si lo necesitas, puedes abrir el tráiler en otra pestaña.';
      const link = document.createElement('a');
      link.href = url.href; link.target = '_blank'; link.rel = 'noopener'; link.textContent = ' Abrir tráiler';
      message.append(link);
    }
    resetBonusShell() {
      this.stopBonusVideo();
      this.dialog.classList.remove('is-vault', 'is-documentary');
    }
    money(amount, currency = this.commerce.currency || 'USD') {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', { style:'currency', currency }).format(amount / 100);
    }
    purchaseMessage(message, error = false) {
      this.status.textContent = message;
      const node = this.querySelector('[data-map-cart-feedback]');
      node.hidden = !message;
      node.textContent = message;
      node.classList.toggle('is-error', error);
      return node;
    }
    async openPurchase(trigger = null) {
      if (this.checkoutBusy || !this.ready) return;
      if (!this.withVault || !this.withoutVault) {
        this.purchaseMessage('Configura las variantes Con Baúl y Sin Baúl en este producto antes de comprar.', true);
        return;
      }
      const needsVault = this.vaultSelection.mode === 'unset' && this.vaultAvailable();
      const invalid = this.vaultSelection.mode === 'with' && (!this.vaultSelection.ids.length || !this.vaultAvailable());
      if (needsVault || invalid) {
        const index = this.vaultIndex();
        if (index >= 0) {
          await this.openPack(index);
          const feedback = this.content.querySelector('[data-vault-feedback]');
          if (feedback) {
            feedback.classList.add('is-required');
            feedback.textContent = invalid ? 'Revisa la disponibilidad. Elige tus bundles o marca Continuar sin Baúl, y guarda tu selección.' : 'Elige entre 1 y 4 bundles o marca Continuar sin Baúl, y guarda tu selección.';
            feedback.focus({preventScroll:true});
            feedback.scrollIntoView({block:'nearest', behavior:'instant'});
          }
        }
        return;
      }
      if (this.vaultSelection.mode === 'unset') this.vaultSelection = { mode:'without', ids:[] };
      if (this.dataset.preview === 'true') {
        this.purchaseMessage('Vista previa: al comprar en la tienda se añadirán Street Edition y tu selección, y se abrirá el carrito lateral. Aquí no se añaden productos.');
        return;
      }
      const api = window.SounplaceCartV7;
      const drawer = document.querySelector('cart-drawer[data-sp-cart-drawer]');
      if (!drawer || !drawer.dataset.sectionId || !api || !['enqueue','getSectionRequests','renderSections','updateCartCount','open'].every(name => typeof api[name] === 'function')) {
        this.purchaseMessage('No se pudo preparar el carrito lateral. Recarga la página e inténtalo de nuevo.', true);
        return;
      }
      if (this.guideOpen) this.finishGuide();
      this.checkoutBusy = true;
      const controls = [...this.querySelectorAll('button'), ...(trigger?.tagName === 'BUTTON' && !this.contains(trigger) ? [trigger] : [])];
      const previousStates = controls.map(button => button.disabled);
      controls.forEach(button => button.disabled = true);
      const links = [...this.querySelectorAll('[data-street-purchase-link]')];
      links.forEach(link => link.setAttribute('aria-busy','true'));
      this.purchaseMessage('Preparando tu carrito…');
      this.mainPlayer.pause();
      this.samplePlayers.forEach(player => player.pause());
      this.stopBonusVideo();
      try {
        const selection = { mode:this.vaultSelection.mode, ids:[...this.vaultSelection.ids] };
        await api.enqueue(() => this.addVaultToCart(selection, api));
        await this.closePack({force:true, returnFocus:false});
        this.purchaseMessage('');
        if (this.expanded) await this.exitExpanded();
        await new Promise(resolve => requestAnimationFrame(resolve));
        if (!this.isConnected) return;
        drawer.setActiveElement?.(trigger || this.querySelector('[data-street-purchase-link]'));
        this.status.textContent = 'Selección añadida al carrito.';
        api.open(true);
      } catch (error) {
        console.error('[Detropolis] Fallo al preparar o abrir el carrito:', error);
        const message = error.name === 'TimeoutError' || error.name === 'AbortError'
          ? 'La conexión tardó demasiado. Los artículos podrían haberse añadido. Puedes volver a pulsar Comprar: comprobaremos el carrito para evitar duplicados.'
          : error.message || 'No se pudo preparar el carrito. Inténtalo de nuevo.';
        const node = this.purchaseMessage(message, true);
        if (this.dialog.open) {
          const feedback = this.content.querySelector('[data-vault-feedback]');
          if (feedback) { feedback.textContent = message; feedback.classList.add('is-required'); feedback.focus({preventScroll:true}); }
        } else {
          if (this.expanded) await this.exitExpanded();
          node.scrollIntoView({block:'nearest', behavior:'instant'});
          node.focus({preventScroll:true});
        }
      } finally {
        this.checkoutBusy = false;
        controls.forEach((button,index) => { if (button.isConnected) button.disabled = previousStates[index]; });
        links.forEach(link => link.removeAttribute('aria-busy'));
        if (!this.dialog.open && this.content.querySelector('[data-vault]')) this.paintVault();
      }
    }
    async cartRequest(path, body) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}${path}`, { method:body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', headers:{ 'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {}) }, ...(body ? {body:JSON.stringify(body)} : {}), signal:AbortSignal.timeout(20000) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito.');
      return data;
    }
    cartSectionsPayload(api, body) {
      const ids = [...new Set(api.getSectionRequests().map(item => item.section))].filter(Boolean).slice(0,5);
      return ids.length ? { ...body, sections:ids, sections_url:`${location.pathname}${location.search}`.slice(0,255) } : body;
    }
        async refreshCartDrawer(cart, api, sections) {
      const drawer = document.querySelector('cart-drawer[data-sp-cart-drawer]');
      const sectionId = drawer?.dataset.sectionId;
      const selector = '[data-sp-cart-render]';
      const isValidPanel = html => typeof html === 'string' &&
        new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

      if (!sectionId || !drawer.querySelector(selector)) {
        throw new Error('No se encontró el panel del carrito. Recarga la página e inténtalo de nuevo.');
      }

      const rendered = { ...(sections || {}) };
      if (!isValidPanel(rendered[sectionId])) {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', sectionId);
        const response = await fetch(url.href, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: '*/*' },
          signal: AbortSignal.timeout(20000)
        });
        if (!response.ok) {
          throw new Error('No pudimos actualizar el panel del carrito. Pulsa Comprar otra vez para reintentarlo sin duplicar los artículos.');
        }
        Object.assign(rendered, await response.json());
      }

      if (!isValidPanel(rendered[sectionId])) {
        throw new Error('La respuesta del carrito no contiene su panel. Los artículos podrían estar añadidos; falta revisar la estructura del carrito del tema.');
      }

      api.renderSections(rendered);
      api.updateCartCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('sounplace:cart-updated', { detail: cart }));
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'detropolis-street-map',
          cartData: cart
        });
      }
    }
    async addVaultToCart(selection, api) {
      const mode = selection.mode;
      const selected = mode === 'with' ? this.catalog.filter(item => selection.ids.includes(item.id)) : [];
      if (!['with','without'].includes(mode) || (mode === 'with' && (!selected.length || selected.length > 4 || selected.length !== selection.ids.length))) throw new Error('Revisa tu selección del Baúl.');
      const product = await this.cartRequest(`products/${encodeURIComponent(this.commerce.handle)}.js`);
      const localVariant = mode === 'with' ? this.withVault : this.withoutVault;
      const variantId = localVariant.id;
      const variant = product.variants.find(item => String(item.id) === String(variantId));
      [this.withVault, this.withoutVault].forEach(item => {
        item.available = !!product.variants.find(
          fresh => String(fresh.id) === String(item.id)
        )?.available;
      });

      if (!variant?.available) {
        const switched = this.selectWithoutVaultIfSoldOut();

        if (!switched) {
          this.dispatchEvent(new CustomEvent('detropolis:vault-updated', {
            bubbles:true,
            detail:{ productId:this.commerce.productId }
          }));
        }

        throw new Error(switched
          ? 'El Baúl acaba de agotarse. La opción ahora es Street Edition sin Baúl. Revisa el precio actualizado y vuelve a pulsar Comprar si deseas continuar.'
          : 'Esta opción acaba de agotarse o no está disponible. Revisa las opciones antes de continuar.');
      }
      if (variant.price !== localVariant.price) {
        localVariant.price = variant.price;
        throw new Error(`El precio de ${mode === 'with' ? 'Con Baúl' : 'Sin Baúl'} se actualizó a ${this.money(variant.price)}. Pulsa Comprar de nuevo si deseas añadirlo con este precio.`);
      }
      let cart = await this.cartRequest('cart.js');
      const owned = item => String(item.properties?._dtm_owner) === String(this.commerce.productId);
      if (cart.items.some(item => String(item.product_id) === String(this.commerce.productId) && !owned(item))) throw new Error('Ya hay una unidad de Street Edition añadida por otra vía. Revisa esa unidad desde el icono del carrito antes de continuar para evitar duplicarla.');
      const old = cart.items.filter(owned);
      const matches = old.length === selected.length + 1 && old.every(item => item.quantity === 1) && old.some(item => item.properties._dtm_role === 'main' && String(item.variant_id) === String(variantId)) && selected.every(bundle => old.some(item => item.properties._dtm_role === 'gift' && String(item.variant_id) === bundle.id));
      let sections;
      if (!matches) {
        if (old.length) await this.cartRequest('cart/update.js', this.cartSectionsPayload(api, { updates:Object.fromEntries(old.map(item => [item.key,0])) }));
        const properties = { _dtm_owner:String(this.commerce.productId), _dtm_role:'main', 'Acceso al Baúl':mode === 'with' ? 'Con Baúl' : 'Sin Baúl' };
        if (selected.length) properties['Bundles del Baúl'] = selected.map(item => item.title).join(' · ');
        const added = await this.cartRequest('cart/add.js', this.cartSectionsPayload(api, { items:[{id:variantId,quantity:1,properties}, ...selected.map(item => ({id:Number(item.id),quantity:1,properties:{_dtm_owner:String(this.commerce.productId),_dtm_role:'gift',_dtm_bonus_kind:'street-vault',_dtm_parent_variant:String(variantId)}}))] }));
        sections = added.sections;
      }
      cart = await this.cartRequest('cart.js');
      const main = cart.items.filter(item => owned(item) && item.properties._dtm_role === 'main');
      const gifts = cart.items.filter(item => owned(item) && item.properties._dtm_role === 'gift');
      await this.refreshCartDrawer(cart, api, sections);
      if (main.length !== 1 || main[0].quantity !== 1 || String(main[0].variant_id) !== String(variantId) || gifts.length !== selected.length || selected.some(bundle => !gifts.some(item => String(item.variant_id) === bundle.id && item.quantity === 1))) throw new Error('El carrito cambió durante la preparación. Revisa los artículos desde el icono del carrito antes de continuar.');
      if (gifts.some(item => item.final_line_price !== 0)) throw new Error('El descuento del Baúl no se aplicó a todos los regalos. Revisa los importes desde el icono del carrito antes de comprar; los artículos podrían seguir añadidos.');
      return cart;
    }

    isEmbeddedTouch() {
      return !this.layoutQuery.matches && !this.expanded;
    }
    clearPointers() {
      const ids = [...this.pointers.keys()];
      this.pointers.clear(); this.drag = null; this.pinch = null; this.suppressClick = false;
      this.frame.classList.remove('is-dragging');
      ids.forEach(id => { if (this.frame.hasPointerCapture(id)) this.frame.releasePointerCapture(id); });
    }
    prepareDemo(route, autoplay = true) {
      const slot = this.querySelector('[data-demo-slot]');
      const url = route === 'detroit' ? slot.dataset.detroitAudio || slot.dataset.westAudio : slot.dataset.westAudio;
      const peaks = route === 'detroit' ? slot.dataset.detroitPeaks || '' : slot.dataset.westPeaks;
      this.mainPlayer.setSource(url, peaks, slot.dataset.title);
      if (autoplay) this.mainPlayer.play();
    }
    syncStage() {
      this.clearPointers();
      this.classList.toggle('is-touch-layout', !this.layoutQuery.matches);
      const demo = this.querySelector('[data-demo-slot]');
      const destination = this.expanded ? this.querySelector('[data-demo-dock]') : this.querySelector('[data-demo-home]');
      if (demo.parentElement !== destination) destination.append(demo);
      this.frame.setAttribute('aria-label', this.isEmbeddedTouch()
        ? 'Mapa de Detropolis. Desliza verticalmente para recorrer la página y horizontalmente para recorrer la ciudad. También puedes elegir un pack en las tarjetas.'
        : 'Mapa interactivo de Detropolis. Arrastra para explorar y pellizca para acercar. Con teclado, usa flechas, más, menos e Inicio.');
      this.querySelector('.dt-street-map__help-touch').textContent = this.expanded
        ? 'Arrastra para explorar · pellizca para acercar'
        : 'Desliza a los lados o elige un pack debajo';
      this.mainPlayer?.paint?.();
    }
    selectPack(index, animate = true, moveRail = true) {
      if (!this.pins.length) return;
      this.selectedPack = clamp(index, 0, this.pins.length - 1);
      this.cards.forEach((card, i) => { card.classList.toggle('is-selected', i === this.selectedPack); card.toggleAttribute('data-selected', i === this.selectedPack); });
      this.pins.forEach((pin, i) => { if (i === this.selectedPack) pin.setAttribute('aria-current', 'true'); else pin.removeAttribute('aria-current'); });
      this.querySelector('[data-card-previous]').disabled = this.selectedPack === 0;
      this.querySelector('[data-card-next]').disabled = this.selectedPack === this.cards.length - 1;
      this.querySelector('[data-card-count]').textContent = `${String(this.selectedPack + 1).padStart(2, '0')} / ${this.cards.length}`;
      this.centerPack(this.selectedPack, animate);
      if (moveRail) this.centerCard(animate);
    }
    centerCard(animate = false) {
      const card = this.cards[this.selectedPack];
      if (!card || !this.rail.clientWidth) return;
      this.railProgrammatic = true;
      clearTimeout(this.railProgramTimer);
      const box = card.getBoundingClientRect(), track = this.rail.getBoundingClientRect();
      this.rail.scrollTo({ left: this.rail.scrollLeft + box.left - track.left + box.width / 2 - track.width / 2, behavior: animate && !this.reduced.matches ? 'smooth' : 'instant' });
      this.railProgramTimer = setTimeout(() => { this.railProgrammatic = false; }, animate && !this.reduced.matches ? 500 : 40);
    }
    railScroll() {
      if (this.railProgrammatic) return;
      clearTimeout(this.railTimer);
      this.railTimer = setTimeout(() => {
        if (!this.events || !this.rail.clientWidth || this.expanded) return;
        const box = this.rail.getBoundingClientRect(), center = box.left + box.width / 2;
        let nearest = 0, distance = Infinity;
        this.cards.forEach((card, i) => { const r = card.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - center); if (d < distance) { distance = d; nearest = i; } });
        this.selectPack(nearest, true, false);
      }, 120);
    }
    initGuide() {
      this.guideKey = 'sounplace:detropolis-street:guide:v1';
      try { this.guideSeen = localStorage.getItem(this.guideKey) === 'done'; } catch (_) { this.guideSeen = false; }
      this.listen(this.querySelector('[data-guide-next]'), 'click', () => this.guideStep < 2 ? this.showGuide(this.guideStep + 1) : this.finishGuide());
      this.listen(this.querySelector('[data-guide-skip]'), 'click', () => this.finishGuide());
      this.listen(window, 'resize', () => { if (this.guideOpen) this.positionGuide(); });
      if (window.visualViewport) this.listen(window.visualViewport, 'resize', () => { if (this.guideOpen) this.positionGuide(); });
    }
    showGuide(step = 0) {
      if (this.dialog.open || !this.ready) return;
      this.guideStep = step; this.guideOpen = true;
      const guide = this.querySelector('[data-guide]');
      guide.hidden = false;
      guide.dataset.step = String(step);
      const touch = !this.layoutQuery.matches;
      const copy = guide.dataset;
      const titles = [
        copy.guideTitle1 || 'Explora la ciudad',
        this.expanded ? (copy.guideTitleClose || 'Continúa por la página') : (copy.guideTitleOpen || 'Amplía la ciudad'),
        copy.guideTitle3 || 'Recupera la vista general'
      ];
      const texts = [
        touch
          ? (this.expanded
            ? (copy.guideTextTouch || 'Arrastra para moverte y pellizca para acercarte. Toca una ubicación para descubrir su pack.')
            : (copy.guideTextEmbed || 'Desliza a los lados o elige una tarjeta. Pulsa Ver pack para descubrir su contenido.'))
          : (copy.guideTextPc || 'Arrastra para explorar la ciudad. Toca una ubicación para descubrir su pack.'),
        this.expanded
          ? (copy.guideTextClose || 'Este botón cierra la vista ampliada. Después puedes recorrer la página y elegir packs en las tarjetas.')
          : (copy.guideTextOpen || 'Este botón abre el mapa ampliado para explorar con más espacio.'),
        copy.guideText3 || 'Este botón muestra la ciudad completa para que puedas volver a orientarte.'
      ];
      guide.querySelector('[data-guide-title]').textContent = titles[step];
      guide.querySelector('[data-guide-text]').textContent = texts[step];
      guide.querySelector('[data-guide-step]').textContent = `${step + 1} / 3`;
      guide.querySelector('[data-guide-next]').textContent = step === 2 ? (copy.guideDoneLabel || 'Entendido') : (copy.guideNextLabel || 'Siguiente');
      this.positionGuide();
      guide.querySelector('[data-guide-next]').focus({ preventScroll: true });
    }
    positionGuide() {
      const target = this.guideStep === 0 ? this.frame : this.querySelector(this.guideStep === 1 ? '[data-expand]' : '[data-fit]');
      const box = target.getBoundingClientRect(), host = this.getBoundingClientRect();
      const guide = this.querySelector('[data-guide]'), spot = guide.querySelector('[data-guide-spot]'), panel = guide.querySelector('[data-guide-panel]');
      const top = Math.max(0, box.top - host.top), left = Math.max(0, box.left - host.left);
      Object.assign(spot.style, { top: `${top}px`, left: `${left}px`, width: `${box.width}px`, height: `${box.height}px`, background: this.guideStep === 0 ? '#0005' : 'transparent' });
      const usable = this.expanded ? this.clientHeight - this.querySelector('[data-demo-dock]').offsetHeight : Math.min(this.clientHeight, window.innerHeight + Math.max(0, -host.top));
      const height = panel.offsetHeight || 180;
      const y = this.guideStep === 0 ? top + Math.max(12, (box.height - height) / 2) : top - height - 14;
      panel.style.top = `${clamp(y, Math.max(12, -host.top + 12), Math.max(12, usable - height - 12))}px`;
      panel.style.left = `${clamp(left, 12, Math.max(12, this.clientWidth - panel.offsetWidth - 12))}px`;
    }
    finishGuide(persist = true) {
      const wasOpen = this.guideOpen;
      this.guideOpen = false;
      this.querySelector('[data-guide]').hidden = true;
      if (persist) {
        this.guideSeen = true;
        if (this.dataset.designMode !== 'true') { try { localStorage.setItem(this.guideKey, 'done'); } catch (_) { } }
      }
      if (wasOpen) this.querySelector('[data-help]').focus({ preventScroll: true });
    }

    dismissHelp() {
      if (this.hasExplored) return;
      this.hasExplored = true;
      this.help.hidden = true;
    }
    prepareDividerFragments(scenes) {
      this.clearDividerFragments();
      this.dividerOriginals = [];
      this.dividerFragments = [];
      const dividers = [...this.entry.querySelectorAll('.dt-entry__divider')];
      dividers.forEach((divider, dividerIndex) => {
        const box = divider.getBoundingClientRect();
        if (!box.width || !box.height) return;
        const stackedLine = divider.querySelector('.dt-entry__divider-stacked');
        const stacked = stackedLine && getComputedStyle(stackedLine).display !== 'none';
        scenes.slice(0, 2).forEach((scene, index) => {
          const sceneBox = scene.getBoundingClientRect();
          const fragment = document.createElement('span');
          fragment.setAttribute('aria-hidden', 'true');
          fragment.dataset.dtmDividerFragment = '';
          const clip = stacked
            ? (index === 0 ? 'polygon(0 0,100% 0,0 100%)' : 'polygon(0 100%,100% 0,100% 100%)')
            : (index === 0 ? 'polygon(0 0,56% 0,44% 100%,0 100%)' : 'polygon(56% 0,100% 0,100% 100%,44% 100%)');
          Object.assign(fragment.style, { position:'absolute', left:`${box.left - sceneBox.left}px`, top:`${box.top - sceneBox.top}px`, width:`${box.width}px`, height:`${box.height}px`, clipPath:clip, pointerEvents:'none', zIndex:'90' });
          const copy = divider.cloneNode(true);
          copy.removeAttribute('id');
          copy.dataset.dtmDividerCopy = '';
          Object.assign(copy.style, { position:'absolute', inset:'0', width:'100%', height:'100%', visibility:'visible', pointerEvents:'none' });
          const replacements = new Map();
          copy.querySelectorAll('[id]').forEach(node => {
            const oldId = node.id;
            node.id = `${oldId}-dtm-${dividerIndex}-${index}`;
            replacements.set(oldId, node.id);
          });
          [copy, ...copy.querySelectorAll('*')].forEach(node => {
            [...node.attributes].forEach(attribute => {
              let value = attribute.value;
              replacements.forEach((next, old) => { value = value.replaceAll(`url(#${old})`, `url(#${next})`); if (value === `#${old}`) value = `#${next}`; });
              if (value !== attribute.value) node.setAttribute(attribute.name, value);
            });
          });
          fragment.append(copy);
          scene.append(fragment);
          this.dividerFragments.push(fragment);
        });
        this.dividerOriginals.push({ node:divider, style:divider.getAttribute('style') });
        divider.style.visibility = 'hidden';
      });
    }
    clearDividerFragments() {
      this.dividerFragments?.forEach(fragment => fragment.remove());
      this.dividerOriginals?.forEach(({node,style}) => { if (style === null) node.removeAttribute('style'); else node.setAttribute('style',style); });
      this.dividerFragments = null;
      this.dividerOriginals = null;
    }
    targetFor(id) {
      if (!id) return null;
      const found = document.getElementById(id) || [...document.querySelectorAll('[id]')].find(node=>node.id.startsWith(`${id}-`));
      const defaults = { SounplaceInsideBundle: '.sounplace-inside-bundle', SounplaceValueBreakdown: '.sounplace-value-list' };
      return found || (defaults[id] ? document.querySelector(defaults[id]) : null);
    }
    updateTargets() {
      this.querySelectorAll('[data-page-target]').forEach(link=>{
        const exists=!!this.targetFor(link.dataset.pageTarget) || (link.hasAttribute('data-street-purchase-link') && !!this.withVault && !!this.withoutVault);
        if (exists) link.removeAttribute('aria-disabled'); else link.setAttribute('aria-disabled','true');
      });
    }
    createEntryCover() {
      this.removeEntryCover();
      const cover = document.createElement('div');
      cover.className = 'dtm-entry-cover';
      const status = document.createElement('span');
      status.className = 'dtm-entry-cover__status';
      status.setAttribute('role','status');
      status.textContent = 'Entrando a Detropolis…';
      cover.append(status);
      document.body.append(cover);
      this.entryCover = cover;
      this.entryMapInert = this.inert;
      this.inert = true;
      this.unlockEntry = lockScroll();
    }
    removeEntryCover() {
      this.entryFade?.cancel();
      this.entryFade = null;
      this.entryCover?.remove();
      this.entryCover = null;
      this.unlockEntry?.();
      this.unlockEntry = null;
      if (this.entryMapInert !== undefined) {
        this.inert = this.entryMapInert;
        this.entryMapInert = undefined;
      }
    }
    waitForEntryCity() {
      if (this.ready) return Promise.resolve(true);
      if (this.city.complete && this.city.naturalWidth) { this.cityReady(); return Promise.resolve(this.ready); }
      return new Promise(resolve => {
        let finished = false;
        const finish = result => {
          if (finished) return;
          finished = true;
          clearTimeout(limit);
          this.city.removeEventListener('load',loaded);
          this.city.removeEventListener('error',failed);
          this.signal.removeEventListener('abort',failed);
          resolve(result);
        };
        const loaded = () => finish(this.ready || this.city.naturalWidth > 0);
        const failed = () => finish(false);
        const limit = setTimeout(failed,6500);
        this.city.addEventListener('load',loaded,{once:true});
        this.city.addEventListener('error',failed,{once:true});
        this.signal.addEventListener('abort',failed,{once:true});
        if (this.city.complete && !this.city.naturalWidth) this.city.src = this.city.getAttribute('src');
      });
    }
    releaseEntryBoot() {
      const boot = window.__detropolisEntryBoot;
      if (boot && this.entry && boot.entryId === this.entry.id) boot.release();
    }
    entrySessionKey() {
      return `sounplace:detropolis:entry:v1:${location.pathname}:${this.dataset.pageKey || this.id}`;
    }
    restoreEntrySession() {
      if (!this.entry || this.dataset.designMode === 'true' || this.dataset.waitEntry !== 'true' || this.entered || this.entering) { this.releaseEntryBoot(); return; }
      let route;
      try { route = sessionStorage.getItem(this.entrySessionKey()); } catch (_) { this.releaseEntryBoot(); return; }
      if (route !== 'west' && route !== 'detroit') { this.releaseEntryBoot(); return; }
      const button = this.entry.querySelector(`[data-dt-choice="${route}"]`);
      if (!button) { this.releaseEntryBoot(); return; }
      this.entry.dataset.selectedRoute = route;
      this.entry.querySelectorAll('[data-dt-choice]').forEach(choice => choice.setAttribute('aria-pressed',String(choice === button)));
      this.enter(route,true);
    }
    startEntryExpansion(restored = false) {
      if (this.layoutQuery.matches || this.expanded || this.dataset.designMode === 'true') return Promise.resolve();
      this.beforeExpanded = {...this.camera};
      this.expandFallback();
      if (restored) return Promise.resolve();
      const target = document.documentElement;
      if (!target.requestFullscreen || document.fullscreenElement) return Promise.resolve();
      this.entryFullscreenTarget = target;
      try {
        const request = target.requestFullscreen();
        return request.catch(() => {}).then(() => {
          if (this.events && !this.entered && !this.entering && document.fullscreenElement === target) document.exitFullscreen().catch(() => {});
        });
      } catch (_) { return Promise.resolve(); }
    }
    async enter(route, restored = false) {
      if (this.entering || this.dataset.designMode === 'true') return;
      route = route === 'detroit' ? 'detroit' : 'west';
      if (this.audioRoute !== route) { this.prepareDemo(route,!restored); this.audioRoute = route; }
      this.entering = true;
      this.createEntryCover();
      const previousCamera = this.sizes.width ? {...this.camera} : null;
      this.cameras[this.route] = previousCamera;
      this.route = route;
      this.dataset.route = route;
      this.querySelector('[data-route-label]').textContent = route === 'west' ? 'West Coast' : 'Detroit Calle';
      const animations = [];
      if (this.entry) {
        this.entryHost = this.entry.closest('.shopify-section') || this.entry;
        if (!this.entrySaved) this.entrySaved = {style:this.entryHost.getAttribute('style'),inert:this.entry.inert,opening:this.entry.hasAttribute('data-dtm-opening')};
        const box = this.entryHost.getBoundingClientRect();
        this.entry.inert = true;
        this.entry.setAttribute('data-dtm-opening','');
        Object.assign(this.entryHost.style,{position:'fixed',top:`${box.top}px`,left:`${box.left}px`,width:`${box.width}px`,height:`${box.height}px`,overflow:'hidden',background:'transparent',zIndex:'2147483001'});
        const scenes = [...this.entry.querySelectorAll('.dt-entry__scene')];
        if (!restored && !this.reduced.matches) this.prepareDividerFragments(scenes);
        scenes.forEach((scene,i) => animations.push(scene.animate([{transform:'translate3d(0,0,0)',opacity:1},{transform:`translate3d(${i === 0 ? '-110%' : '110%'},${i === 0 ? '-10%' : '10%'},0)`,opacity:0}],{duration:restored || this.reduced.matches ? 0 : 500,delay:restored || this.reduced.matches || scene.dataset.route === route ? 0 : 45,easing:'cubic-bezier(.3,0,.2,1)',fill:'forwards'})));
        const header = this.entry.querySelector('.dt-entry__header');
        if (header) animations.push(header.animate([{opacity:1},{opacity:0}],{duration:restored || this.reduced.matches ? 0 : 180,fill:'forwards'}));
        this.entryAnimations = animations;
      }
      this.hidden = false;
      const expansion = this.startEntryExpansion(restored);
      const opening = Promise.allSettled(animations.map(animation => animation.finished)).then(() => {
        if (this.entryHost && this.events) { this.entryHost.style.display = 'none'; this.releaseEntryBoot(); }
        animations.forEach(animation => animation.cancel());
        this.clearDividerFragments();
        this.entryAnimations = null;
      });
      try {
        if (!await this.waitForEntryCity()) throw new Error('city');
        if (!this.events) return;
        this.scrollEntryDestination();
        this.fitEmbeddedHeight();
        this.resize();
        const saved = this.cameras[route];
        if (saved) this.setCamera(saved); else this.initialCamera();
        await Promise.all([opening,Promise.race([expansion,new Promise(resolve => setTimeout(resolve,900))])]);
        if (!this.events) return;
        this.scrollEntryDestination();
        this.fitEmbeddedHeight();
        this.resize();
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        if (!this.events) return;
        this.dispatchEvent(new CustomEvent('detropolis:route-ready',{bubbles:true,detail:{route,demoSlot:this.querySelector('[data-demo-slot]')}}));
        if (!this.reduced.matches && this.entryCover) {
          this.entryFade = this.entryCover.animate([{opacity:1},{opacity:0}],{duration:200,easing:'ease-out',fill:'forwards'});
          await this.entryFade.finished.catch(() => {});
        }
        if (!this.events) return;
        this.entered = true;
        try { sessionStorage.setItem(this.entrySessionKey(),route); } catch (_) { }
        this.removeEntryCover();
        const destination = this.entryDestination();
        (destination === this ? this.querySelector('[data-map-heading]') : destination.querySelector('h1,h2,h3'))?.focus({preventScroll:true});
        this.status.textContent = `Entrada ${route === 'west' ? 'West Coast' : 'Detroit Calle'}. Explora las ubicaciones para descubrir los packs.`;
        this.entering = false;
        this.syncSparkles();
        if (!this.guideSeen && (!this.layoutQuery.matches || this.entryDestination() === this)) this.showGuide();
      } catch (_) {
        animations.forEach(animation => animation.cancel());
        await opening;
        if (!this.events) return;
        if (this.expanded) await this.exitExpanded();
        this.hidden = true;
        this.restoreEntry();
        this.mainPlayer.pause();
        this.audioRoute = null;
        this.entered = false;
        this.entering = false;
        this.removeEntryCover();
        this.entry?.scrollIntoView({block:'start',behavior:'instant'});
        const status = this.entry?.querySelector('.dt-entry__status');
        if (status) status.textContent = 'No se pudo preparar la ciudad. Pulsa la entrada para reintentar.';
        this.entry?.querySelector(`[data-dt-choice="${route}"]`)?.focus({preventScroll:true});
      }
    }
    restoreEntry() {
      this.releaseEntryBoot();
      this.clearDividerFragments();
      if(!this.entrySaved || !this.entryHost) return;
      if(this.entrySaved.style===null) this.entryHost.removeAttribute('style'); else this.entryHost.setAttribute('style',this.entrySaved.style);
      this.entry.inert=this.entrySaved.inert;
      this.entry.toggleAttribute('data-dtm-opening',!!this.entrySaved.opening);
      this.entrySaved=null;
    }
    async changeEntry() {
      if(!this.entry || this.entering) return;
      if(this.dialog.open) this.dialog.close();
      if(this.expanded) await this.exitExpanded();
      this.mainPlayer.pause();
      this.audioRoute = null;
      this.entered = false;
      this.cameras[this.route]={...this.camera};
      this.dispatchEvent(new CustomEvent('detropolis:route-leaving',{bubbles:true,detail:{route:this.route}}));
      this.restoreEntry();
      this.hidden=true;
      this.entry.scrollIntoView({block:'start',behavior:'instant'});
      this.entry.querySelector(`[data-dt-choice="${this.route}"]`)?.focus({preventScroll:true});
    }
    async toggleExpanded() {
      if(this.expanded) return this.exitExpanded();
      if (this.guideOpen) this.finishGuide();
      this.beforeExpanded={...this.camera};
      if(this.requestFullscreen) {
        try { await this.requestFullscreen(); return; } catch (_) { }
      }
      this.expandFallback();
    }
    expandFallback() {
      this.expanded=true;
      this.classList.add('is-expanded');
      this.unlockExpanded=lockScroll();
      this.inertNodes=[];
      let node=this;
      while(node.parentElement && node.parentElement!==document.documentElement) {
        [...node.parentElement.children].forEach(sibling=>{
          if(sibling!==node && sibling!==this.entryCover && !sibling.inert) { sibling.inert=true; this.inertNodes.push(sibling); }
        });
        node=node.parentElement;
      }
      this.updateExpanded();
    }
    async exitExpanded() {
      if (this.guideOpen) this.finishGuide();
      if(document.fullscreenElement===this || document.fullscreenElement===this.entryFullscreenTarget) {
        await document.exitFullscreen();
        if (!this.classList.contains('is-expanded')) return;
      }
      this.expanded=false;
      this.classList.remove('is-expanded');
      this.unlockExpanded?.();
      this.unlockExpanded=null;
      this.inertNodes?.forEach(node=>{node.inert=false;});
      this.inertNodes=[];
      this.updateExpanded();
    }
    fullscreenChange() {
      const entryFullscreen = !!this.entryFullscreenTarget && document.fullscreenElement === this.entryFullscreenTarget;
      const exitedEntryFullscreen = this.entryFullscreenActive && !entryFullscreen;
      this.entryFullscreenActive = entryFullscreen;
      if (exitedEntryFullscreen && this.classList.contains('is-expanded')) { this.exitExpanded(); return; }
      this.expanded=document.fullscreenElement===this || this.classList.contains('is-expanded');
      this.updateExpanded();
    }
    updateExpanded() {
      this.syncStage();
      this.querySelector('[data-expand-label]').textContent=this.expanded?'Salir del mapa ampliado':'Ampliar mapa';
      this.querySelector('[data-expand]').setAttribute('aria-pressed',String(this.expanded));
      this.querySelector('[data-expand]').setAttribute('aria-label',this.expanded?'Salir del mapa ampliado':'Ampliar mapa');
      this.fitEmbeddedHeight();
      this.resize();
      if (!this.entering) this.querySelector('[data-expand]').focus({preventScroll:true});
      if (!this.expanded) {
        if (!this.layoutQuery.matches) this.selectPack(this.selectedPack, false);
        cancelAnimationFrame(this.exitFrame);
        this.exitFrame = requestAnimationFrame(() => {
          if (!this.events || this.expanded) return;
          this.fitEmbeddedHeight();
          this.frame.scrollIntoView({ block:'start', behavior:'instant' });
        });
      }
    }
    documentKey(event) {
      if (this.guideOpen && event.key === 'Escape') { event.preventDefault(); this.finishGuide(); return; }
      if(!this.expanded || this.dialog.open) return;
      if(event.key==='Escape' && this.classList.contains('is-expanded')) {event.preventDefault();this.exitExpanded();}
      if(event.key==='Tab' && this.classList.contains('is-expanded')) {
        const nodes=[...this.querySelectorAll('button:not(:disabled),a[href],[tabindex="0"]')].filter(node=>node.getClientRects().length && !node.closest('dialog') && getComputedStyle(node).visibility!=='hidden');
        const first=nodes[0],last=nodes[nodes.length-1];
        if(event.shiftKey && document.activeElement===first) {event.preventDefault();last?.focus();}
        else if(!event.shiftKey && document.activeElement===last) {event.preventDefault();first?.focus();}
      }
    }
    fitEmbeddedHeight() {
      if (!this.frame || !this.isEmbeddedTouch()) return;
      const rail = this.querySelector('.dt-street-map__rail');
      const height = window.visualViewport?.height || window.innerHeight;
      const styles = getComputedStyle(this);
      const preferred = parseFloat(styles.getPropertyValue(innerWidth < 750 ? '--dtm-height-m' : '--dtm-height-t')) || 510;
      const available = Math.max(160, Math.floor(height - rail.getBoundingClientRect().height - 16));
      const value = `${Math.min(preferred, available)}px`;
      if (this.style.getPropertyValue('--dtm-embedded-height') !== value) this.style.setProperty('--dtm-embedded-height', value);
    }
    initPagePosition() {
      if (this.dataset.designMode === 'true') return;
      document.documentElement.classList.add('dtm-product-page');
      this.positionKey = `sounplace:detropolis:position:${location.pathname}:${this.dataset.pageKey || this.id}`;
      try { this.returnSection = sessionStorage.getItem(this.positionKey); } catch (_) { }
      this.previousScrollRestoration = history.scrollRestoration;
      history.scrollRestoration = 'manual';
      this.listen(window, 'pagehide', () => this.rememberSection());
      this.listen(window, 'beforeunload', () => this.rememberSection());
      this.listen(window, 'pageshow', event => {
        if (event.persisted && this.entered && !this.expanded) this.scrollEntryDestination();
      });
    }
    pageSections() {
      const main = this.closest('main') || document.querySelector('main') || document.body;
      const sections = [...main.querySelectorAll('.shopify-section[id], [data-dtm-section][id]')];
      [this.targetFor('SounplaceInsideBundle'), this.targetFor('SounplaceValueBreakdown')].forEach(node => {
        if (node && !node.closest('.shopify-section') && !sections.includes(node)) sections.push(node);
      });
      return sections.filter(node => !node.contains(this.entry) && node.getClientRects().length);
    }
    rememberSection() {
      if (!this.entered || this.dataset.designMode === 'true') return;
      let id = 'map';
      if (!this.expanded) {
        const marker = Math.min(100, innerHeight * .2);
        const mapBox = this.getBoundingClientRect();
        if (!(mapBox.top <= marker && mapBox.bottom > marker)) {
          const section = this.pageSections().filter(node => {
            const box = node.getBoundingClientRect();
            return box.top <= marker && box.bottom > marker;
          }).sort((a, b) => b.getBoundingClientRect().top - a.getBoundingClientRect().top)[0];
          if (section && !section.contains(this)) id = section.id;
        }
      }
      this.returnSection = id;
      try { sessionStorage.setItem(this.positionKey, id); } catch (_) { }
    }
    entryDestination() {
      if (!this.layoutQuery.matches || !this.returnSection || this.returnSection === 'map') return this;
      const node = document.getElementById(this.returnSection);
      return node && !node.contains(this) && this.pageSections().includes(node) ? node : this;
    }
    scrollEntryDestination() {
      this.entryDestination().scrollIntoView({ block:'start', behavior:'instant' });
    }
    disconnectedCallback() {
      this.releaseEntryBoot();
      this.destroySparkles();
      this.removeEntryCover();
      if (document.fullscreenElement === this.entryFullscreenTarget) document.exitFullscreen().catch(() => {});
      this.packSequence = (this.packSequence || 0) + 1;
      this.packMotion?.cancel();
      this.stopBonusVideo();
      cancelAnimationFrame(this.exitFrame);
      if (this.previousScrollRestoration !== undefined) history.scrollRestoration = this.previousScrollRestoration;
      if (![...document.querySelectorAll('detropolis-street-map')].some(node => node !== this)) document.documentElement.classList.remove('dtm-product-page');
      this.mainPlayer?.destroy();
      this.samplePlayers?.forEach(player => player.destroy());
      clearTimeout(this.railTimer);
      clearTimeout(this.railProgramTimer);
      this.events?.abort();
      this.events=null;
      this.observer?.disconnect();
      this.railObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
      cancelAnimationFrame(this.paint);
      this.stopAnimation();
      this.entryAnimations?.forEach(animation=>animation.cancel());
      this.restoreEntry();
      this.unlockDialog?.();
      this.unlockExpanded?.();
      this.inertNodes?.forEach(node=>{node.inert=false;});
      clearTimeout(this.detailTimer);
      this.detailTimer = 0;
      this.detailPending = '';
      if(this.detailImage) {this.detailImage.onload=null;this.detailImage.onerror=null;this.detailImage=null;}
      if(this.dialog?.open) this.dialog.close();
    }
  }
  customElements.define('detropolis-street-map',DetropolisMap);
})();
